import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { useLocation } from 'react-router-dom';
// import { getLanguage } from '../../../../utils/params';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  // Marker
} from "react-google-maps";
import { compose, withProps } from 'recompose';
import MarkerIcon from './map/MarkerIcon';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer'
import { PinpointListProject } from 'assets/images/icon'
import { useTranslation } from 'react-i18next';

const getLanguage = localStorage.getItem('language');
let setLanguage = '';
if (getLanguage === 'jp') {
  setLanguage = 'ja';
} else if (getLanguage === 'en') {
  setLanguage = 'en';
} else if (getLanguage === 'vi') {
  setLanguage = 'vi';
}

const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_KEY_GOOGLE_MAP}&language=${setLanguage}&v=3.exp&libraries=visualization,geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `600px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(props => {

  const [isOpen, setIsOpen] = useState(null);

  const handleShowPopup = (data) => {
    setTimeout(() => setIsOpen(data), 100);
    // setIsOpen(data)
  }

  const handleClosePopup = () => {
    setTimeout(() => setIsOpen(null), 100);
  }

  return (
    <GoogleMap zoom={props.zoom} center={props.defaultCenter}>
      <MarkerClusterer
        averageCenter
        // calculator={markerClustererCalculator}
        enableRetinaIcons
        gridSize={30}
        styles={[
          {
            url: PinpointListProject,
            height: 53,
            lineHeight: 47,
            width: 45,
            textSize: 16,
          }]}
      >
        {props.listMarkers ? props.listMarkers.map((marker, index) =>

          <MarkerIcon key={index} marker={marker} isOpen={isOpen} onToggleOpen={(data) => handleShowPopup(data)} onToggleClose= {() => handleClosePopup()}/>
        ) : ''}
      </MarkerClusterer>
    </GoogleMap>
  );
});

const Map = props => {
  //   const language = getLanguage(useLocation());
  const { t } = useTranslation();

  return (
    <>
      <div id="myMap" className="row find-property-map">
        <div className="col-12">
          <h1 className="detail-apartment-title mt-3">{t('search_property.map')}</h1>
          <MyMapComponent listMarkers={props.allProjects} defaultCenter={props.defaultCenter} zoom={props.zoom}/>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Map);
